<template>
	<div class="opening bodyFont">

    <header class="header">
      <div class="logos-help-row">
        <logo/>
        <help-button/>
      </div>
      <h3 class="heading">Perennial<br/>Garden</h3>
      <h4 class="sub-heading">Interactive Mobile Guide</h4>
      <router-link class="button" to="/intro">Start Experience</router-link>
    </header>

    <div id="backdrop">
      <img src="../assets/opening/home-bg-image.jpg"><!-- Change text on this image -->
    </div>

    <FooterLogos />
  </div>

</template>

<script>
// import TinySlider from 'vue-tiny-slider'
// import 'tiny-slider/dist/tiny-slider.css'

export default {
  components: {
  },
  name: 'intro',
  methods: {
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
.header{
	padding-bottom: 30px;
}
.heading{
  margin-bottom: 0;
  font-size:40px;
  line-height: 1.1;
}
.sub-heading{
  margin-bottom:15px;
  font-size:inherit;
}
.heading,.sub-heading{
  text-transform:uppercase;
  font-family:inherit;
}
.opening {
  height: auto !important;
  height: auto !important;
  position: relative;
  color: #000;
  // height: 100%;
  // overflow: scroll;
  // background: url('../assets/opening/backdrop-with-text.jpg');
  // background-size: cover;
  // background-position: top;
  // display: flex;
  // flex-direction: column;
  // justify-content: space-between;
  font-size: 0.8rem;
  .button {
    border-radius: 15px;
    padding: 10px 20px;
  }
  .controls {
    display: flex;
    justify-content: space-around;
  }
}
.rotate {
  max-width: 80px;
}
.logos-help-row{
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	margin: 0 auto;
	max-width: 1000px;

	.help-button{
		// height: 60px;
		// width: 60px;
		// font-size: 30px;
		margin-right: 15px;
	}
}
.overlay {
  position:absolute;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  .help {
    padding: 10px;
    text-align: right;
    flex: 0;
  }
  .content {
    color: white;
    padding: 20px 0 40px;
    // display: flex;
    // flex: 0;
    // flex-direction: column;
    background-color: rgba(0, 0, 0, 1);
    // padding: 20px;
  }
}

.logos{
		background: #000;
		margin: 0 auto;
		// max-width: 1000px;
		width: 100%;
		padding: 0 30px;
		position: absolute;
		bottom: 0;
	img {
      display: block;
      max-width: 80%;
      margin: 0 auto;
    }
}

</style>
